
import { qimoChat } from '~/plugins/ronglianqimo-service';

export default {
  //接收对象参数
  props: {
    listObject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      active: 0,
      desTitle: "供应链电商",
      subtitle: "供应链电商",
      describe:
        "有效整合上游供应链资源，搭建结合供应商的新零售平台，为渠道商/采购商提供海量货源，渠道商/采购商上架到店铺，再通过平台丰富的营销工具，为终端消费者提供服务。从而提升供应链效率，降低商家成本并实时满足消费者多维度商品需求",
      iconarrs: [
        { id: 0, name: "供应商管理", icon: "juude_svg_1" },
        { id: 1, name: "商品采购", icon: "juude_svg_2" },
        { id: 2, name: "供应商城", icon: "juude_svg_3" },
        { id: 3, name: "一件铺货", icon: "juude_svg_4" },
        { id: 4, name: "营销活动", icon: "juude_svg_5" },
        { id: 5, name: "智能调价", icon: "juude_svg_6" },
      ],
      tabChangeArrs: [
        {
          id: 0,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "供应商管理", icon: "juude_svg_1" },
            { id: 1, name: "商品采购", icon: "juude_svg_2" },
            { id: 2, name: "供应商城", icon: "juude_svg_3" },
            { id: 3, name: "一件铺货", icon: "juude_svg_4" },
            { id: 4, name: "营销活动", icon: "juude_svg_5" },
            { id: 5, name: "智能调价", icon: "juude_svg_6" },
          ],
        },
        {
          id: 1,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "在线商城", icon: "juude_svg_8" },
            { id: 1, name: "门店管理", icon: "juude_svg_7" },
            { id: 2, name: "供应商管理", icon: "juude_svg_1" },
            { id: 3, name: "营销活动", icon: "juude_svg_5" },
            { id: 4, name: "会员管理", icon: "juude_svg_25" },
            { id: 5, name: "商品管理", icon: "juude_svg_19" },
          ],
        },
        {
          id: 2,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "商户管理", icon: "juude_svg_7" },
            { id: 1, name: "在线商城", icon: "juude_svg_8" },
            { id: 2, name: "营销活动", icon: "juude_svg_9" },
            { id: 3, name: "财务对账", icon: "juude_svg_10" },
            { id: 4, name: "分账对账", icon: "juude_svg_11" },
            { id: 5, name: "同城配送", icon: "juude_svg_12" },
          ],
        },
        {
          id: 3,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "库存盘点", icon: "juude_svg_13" },
            { id: 1, name: "批量采购", icon: "juude_svg_14" },
            { id: 2, name: "智能调价", icon: "juude_svg_15" },
            { id: 3, name: "安全支付", icon: "juude_svg_16" },
            { id: 4, name: "数据同步", icon: "juude_svg_17" },
            { id: 5, name: "财务报表", icon: "juude_svg_18" },
          ],
        },
        {
          id: 4,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "商品管理", icon: "juude_svg_19" },
            { id: 1, name: "直播卖货", icon: "juude_svg_20" },
            { id: 2, name: "营销活动", icon: "juude_svg_20" },
            { id: 3, name: "库存盘点", icon: "juude_svg_13" },
            { id: 4, name: "推广员", icon: "juude_svg_23" },
            { id: 5, name: "分账结算", icon: "juude_svg_24" },
          ],
        },
        {
          id: 5,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "CRM营销", icon: "juude_svg_25" },
            { id: 1, name: "分销裂变", icon: "juude_svg_26" },
            { id: 2, name: "会员价", icon: "juude_svg_27" },
            { id: 3, name: "会员营销", icon: "juude_svg_28" },
            { id: 4, name: "一键触达", icon: "juude_svg_29" },
            { id: 5, name: "营销转化", icon: "juude_svg_30" },
          ],
        },
        {
          id: 6,
          title: "",
          subtitle: "",
          describe: "",
          arr: [
            { id: 0, name: "在线商城", icon: "juude_svg_8" },
            { id: 1, name: "门店管理", icon: "juude_svg_7" },
            { id: 2, name: "打折促销", icon: "juude_svg_13" },
            { id: 3, name: "一件铺货", icon: "juude_svg_5" },
            { id: 4, name: "商品管理", icon: "juude_svg_19" },
            { id: 5, name: "小时达", icon: "juude_svg_36" },
          ],
        },
      ],
    };
  },
  methods: {
    //移动切换
    changeTab(index) {
      this.active = index;
      this.subtitle = this.listObject.dynamicElement[index].title;
      this.describe = this.listObject.dynamicElement[index].illustrate;

      this.iconarrs = this.tabChangeArrs[index].arr || [];
      // this.iconarrs = this.listObject.dynamicElement[index].childList  接口目前返回的数据有问题
    },
    qimoChat,
  },
  mounted() {
    // this.iconarrs = this.listObject.dynamicElement[0].childList
    this.iconarrs = this.tabChangeArrs[0].arr;
  },
};
